import React from 'react';

const AdminComponent = () => {
    return (
        <div>
            <h1>Admin HomePage</h1>
        </div>
    );
};

export default AdminComponent;